import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

const ThemeSwitcher = ({ changeTheme }) => {
  const [bottom, setBottom] = useState(0);
  let bottomPos = bottom + 'px';

  useEffect(() => {
    // Update the component css position
    bottomPos = bottom + 'px';
  });

  return (
    <div className="theme-switch">
      <b className="switch-link">Theme:</b>&nbsp;
      <a
        className="switch-link"
        onClick={() => changeTheme('fivepm')}
        onKeyDown={() => changeTheme('fivepm')}
        role="link"
        tabIndex="0"
      >
        (5pm)
      </a>
      &nbsp;
      <a
        className="switch-link"
        onClick={() => changeTheme('wowcher')}
        onKeyDown={() => changeTheme('wowcher')}
        role="link"
        tabIndex="0"
      >
        (Wowcher)
      </a>
      &nbsp;
      <a
        className="switch-link"
        onClick={() => changeTheme('living-social')}
        onKeyDown={() => changeTheme('living-social')}
        role="link"
        tabIndex="0"
      >
        (Livingsocial)
      </a>
      <a
        className="switch-link"
        onClick={() => changeTheme('wowcher-christmas')}
        onKeyDown={() => changeTheme('wowcher-christmas')}
        role="link"
        tabIndex="0"
      >
        (Wowcher Xmas)
      </a>
      <a
        className="switch-link"
        onClick={() => changeTheme('livingsocial-christmas')}
        onKeyDown={() => changeTheme('livingsocial-christmas')}
        role="link"
        tabIndex="0"
      >
        (Livingsocial Xmas)
      </a>
      &nbsp;
      <a
        className="switch-link"
        onClick={() => changeTheme('wowcher-blackfriday')}
        onKeyDown={() => changeTheme('wowcher-blackfriday')}
        role="link"
        tabIndex="0"
      >
        (Wowcher Black Friday)
      </a>
      <a
        className="switch-link"
        onClick={() => changeTheme('livingsocial-blackfriday')}
        onKeyDown={() => changeTheme('livingsocial-blackfriday')}
        role="link"
        tabIndex="0"
      >
        (Livingsocial Black Friday)
      </a>
      &nbsp;
      <a
        className="switch-link"
        onClick={() => changeTheme('vip')}
        onKeyDown={() => changeTheme('vip')}
        role="link"
        tabIndex="0"
      >
        (Vip)
      </a>
      &nbsp;&nbsp;
      <a
        className="switch-link"
        onClick={() => setBottom(bottom + 50)}
        onKeyDown={() => setBottom(bottom + 50)}
        role="link"
        tabIndex="0"
      >
        Up&#8679;
      </a>
      &nbsp;
      <a
        className="switch-link"
        onClick={() => setBottom(bottom - 50)}
        onKeyDown={() => setBottom(bottom - 50)}
        role="link"
        tabIndex="0"
      >
        Down&#8681;
      </a>
      <style jsx>{`
        .theme-switch {
          background-color: #ffffff;
          border: 1px #999 solid;
          bottom: ${bottomPos};
          left: 0px;
          padding: 5px;
          position: fixed;
          z-index: 999;
        }
        .switch-link {
          color: #666666;
        }
      `}</style>
    </div>
  );
};

ThemeSwitcher.propTypes = {
  changeTheme: PropTypes.func,
};

export default ThemeSwitcher;
